import axios from "axios";
import { IUser } from "../store/types";

class Api {
  base = "";

  constructor(base: string) {
    this.base = base;
  }

  postUser = async (user: IUser) => {
    if (!this.base) {
      throw new Error("API base URL is not configured");
    }
    return await axios.post(this.base + "/users", user, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  validateReferralCode = async (code: string) => {
    if (!this.base) {
      throw new Error("API base URL is not configured");
    }
    return await axios.get(this.base + "/verifyReferralCode/" + code);
  };
}

export default (base: string) => new Api(base);
export type { Api };
